import { Autocomplete, Box, TextField, Typography } from '@mui/material'
import { t } from 'i18next'
import { Option } from '../../components/Form/Inputs/SelectInput'
import EmploymentType from '../../store/types/enums/EmploymentType'

type AutocompleteEmploymentTypesProps = {
  value: EmploymentType
  onChange: (value: EmploymentType) => void
}
export const employmentTypesOptions: Option[] = [
  { value: EmploymentType.EMPLOYMENT_CONTRACT, label: `page.employments.types.${EmploymentType.EMPLOYMENT_CONTRACT}` },
  { value: EmploymentType.B2B, label: `page.employments.types.${EmploymentType.B2B}` },
  { value: EmploymentType.MANDATE_CONTRACT, label: `page.employments.types.${EmploymentType.MANDATE_CONTRACT}` },
  { value: EmploymentType.WORK_CONTRACT, label: `page.employments.types.${EmploymentType.WORK_CONTRACT}` },
]

const AutocompleteEmploymentTypes = ({ value, onChange }: AutocompleteEmploymentTypesProps) => {
  return (
    <Autocomplete
      value={employmentTypesOptions.find(opt => opt.value === value) || undefined}
      onChange={(_, newValue) => {
        if (newValue) {
          onChange(newValue.value as EmploymentType)
        }
      }}
      disableClearable
      aria-label={t('page.employments.dialog.form.type')}
      options={employmentTypesOptions}
      getOptionLabel={option => t(option.label)}
      noOptionsText={t('page.employments.dialog.form.type')}
      renderGroup={params => (
        <div key={params.key}>
          <Box sx={{ px: 1.5, py: 1 }}>
            <Typography variant="body1" sx={{ color: 'text.highEmphasis' }}>
              {params.group}
            </Typography>
          </Box>
          <Box sx={{ color: 'text.base' }}>{params.children}</Box>
        </div>
      )}
      renderInput={params => (
        <TextField {...(params as any)} size={'small'} label={t('page.employments.dialog.form.type')} />
      )}
      isOptionEqualToValue={(option, val) => {
        return option.value === (val as Option)?.value
      }}
    />
  )
}

export default AutocompleteEmploymentTypes
